<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Notification from "@/services/Notification";
    import Monitor from "@/services/Monitor";
    import ModalEditAutomatedNotification from "@/components/modals/notification/modalEditAutomatedNotification";
    import ModalAddAutomatedNotification from "@/components/modals/notification/modalAddAutomatedNotification";
    import Swal from "sweetalert2";
    import ModalViewNotificationAttributes from "@/components/modals/notification/modalViewNotificationAttributes.vue";
    import ModalAddAutomatedNotificationSetup
      from "@/components/modals/notification/modalAddAutomatedNotificationSetup.vue";
    import Business from "@/services/Business";

    export default {
        components: {
          ModalAddAutomatedNotificationSetup,
            Layout,
            PageHeader,
            ModalEditAutomatedNotification,
            ModalAddAutomatedNotification,
            ModalViewNotificationAttributes,
        },
        page: {
            title: "Notifications Setup",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                error: null,
                tableData: [],
                tableDataTournament: [],
                title: "Notifications Setup",
                items: [
                    {
                        text: "Notifications",
                    },
                    {
                        text: "Notifications Setup",
                        active: true,
                    },
                ],
                filterInput: {},
                isBusy: false,
                totalRows: 0,
                totalRowsTournament: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                access_object: localStorage.getItem("access_objects"),
                sortBy: "valid_from",
                sortDesc: true,
                isActive: '',
                dealData: [],
                tenantData: [],
                notificationData: [],
                fields: [
                    {
                        key: "type",
                        label: "Type",
                        visible: true,
                    },
                    {
                      key:"attributes",
                      label: "Attributes",
                      visible: true,
                    },
                    {
                      key: "language",
                      label: "Language",
                   },
                    {
                      key: "tenant",
                       label: "Tenant",
                    },
                    {
                        key: "active",
                        label: "Active",
                        visible: true,
                    },
                    {
                        key: "Action",
                        label: "Action",
                    }
                ],
                statusOptions: [],
                isBusyAll: false,
                totalRowsAll: 0,
                currentPageAll: 1,
                perPageAll: 10,
                pageOptionsAll: [10, 25, 50, 100],
                filterAll: null,
                filterOnAll: [],
                typeNew: [],
                filterData: false,
                verifyInput: "",
                loading: false
            };
        },

        async created() {
            await this.getAutomatedNotifications();
            if(this.objToArray.includes('notificationSetup.showTenantSelect')){
              await this.getAllTenants();
            }
        },
        computed: {
            tenantOptions() {
                return this.tenantData.map(tenant => ({
                    value: tenant,
                    text: tenant
                }));
            },
            objToArray(){
              return this.access_object.split(',');
            },
        },
        methods: {
            handleTenantChange(selectedTenant) {
                if (selectedTenant) {
                    this.getAutomatedNotifications(selectedTenant);
                } else {
                    // Hide table when "All Tenants" is selected or selection is cleared

                    this.tableData = [];
                    this.totalRows = 0;
                }
            },
          async deleteNotification(id){
            Swal.fire({
              title:"Delete Automated Notification?",
              text:"This Automated Notification will be deleted!",
              icon:"warning",
              showCancelButton:true,
              confirmButtonColor:"#34c38f",
              cancelButtonColor:"#f46a6a",
              confirmButtonText:"Delete"
            }).then(async (result)=>{
              if(result.isConfirmed === true){
                try {
                  const response  = await  Notification.deleteNotificationSetup(id);
                  if(response.data.success === true){
                    await this.getAutomatedNotifications(this.verifyInput);
                    Swal.fire("Success!", "Automated Notification is successfully deleted!", "success");
                  }else{
                    const error = response.error ? response.error : 'Failed';
                    Swal.fire("Fail!", error, "warning");
                  }
                }catch (error) {
                  this.error = error.response && error.response.data && error.response.data.error
                      ? error.response.data.error
                      : "An error occurred while removing the Automated Notification.";
                  Swal.fire("Error", this.error, "error");
                }

              }
            })
          },
            async getAllTenants() {
                try {
                    this.isBusy = true;
                    const response = await Monitor.getAllTenants();

                    this.tenantData = response.data.data.map(item => item.tenant);
                    this.isBusy = false;
                } catch (error) {
                    this.isBusy = false;
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.totalRows = 0
                }
            },
            async getAutomatedNotifications(tenant = null) {
                try {
                    this.typeNew = [];
                    this.isBusy = true;

                    if(this.objToArray.includes('notificationSetup.showTenantSelect')){
                      this.filterData = tenant !== null;
                    }else{
                      this.filterData = tenant = process.env.VUE_APP_TENANT;
                    }

                    console.log(this.filterData,'filterData');
                    console.log(tenant,'tenantData');

                    const query = tenant ? `tenant=${tenant}` : '';
                    const response = await Notification.getAutomatedNotification(query);

                    this.tableData = response.data || [];
                    this.isActive = this.tableData.some(item => item.active === 1);
                    this.totalRows = this.tableData.length;
                    console.log(this.tableData,'table data')
                } catch (error) {
                    this.isBusy = false;
                    this.error = error.response?.data?.error || "";
                    this.tableData = [];
                    this.totalRows = 0;
                    this.typeNew = [];
                    this.filterData = false;
                } finally {
                    this.isBusy = false;
                }
            },
            callModalEditTeamDeal(data) {
                this.$bvModal.show("edit_automated_notification");
                this.notificationData = data
            },
            callModalAddNotification() {
              this.$bvModal.show("add_notification_setup");
            },
            callModalViewAttributes(data) {
              this.$bvModal.show("view_notifications_attributes");
              this.notificationData = data
            },


        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" :fields="fields"/>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2">
                                <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
                                   @click="callModalAddNotification">
                                    <i class="mdi mdi-plus me-2"></i>Create Automated Notification
                                </a>
                            </div>
                        </div>
                        <div v-if="objToArray.includes('notificationSetup.showTenantSelect')" class="row justify-content-center text-center">
                            <div class="col-sm-12 col-md-2">
                                <p>Select Tenant</p>
                                <b-form-select
                                        v-model="verifyInput"
                                        :options="tenantOptions"
                                        class="me-2"
                                        :disabled="isBusy"
                                        @change="handleTenantChange"
                                >
                                    <template #first>
                                        <option :value="null">All Tenants</option>
                                    </template>
                                </b-form-select>
                            </div>
                        </div>
                        <!-- Add the message here -->
                        <div v-if="!verifyInput" class="row justify-content-center mt-2">
                            <div v-if="objToArray.includes('notificationSetup.showTenantSelect')" class="col-sm-12 col-md-6">
                                <div class="alert alert-info">
                                    <i class="uil uil-info-circle me-2"></i> Please select a tenant to view notifications
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col d-inline-flex align-items-center">
                                <h4 class="card-title m-0">Total Automated Notification Setup: {{ totalRows }}</h4>
                            </div>
                        </div>
                        <div class="row mt-4" v-show="filterData">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="deals-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>

                        <!-- Table -->
                        <div class="table-responsive mb-0 font-size-12" v-show="filterData">
                            <b-table
                                    :items="tableData"
                                    :busy="isBusy"
                                    :fields="fields"
                                    :visible="fields.visible"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                            >

                               <template v-slot:cell(attributes)="data">
                                  <div  class="col-4">
                                    <i style="cursor: pointer; color: #5b73e8" @click="callModalViewAttributes(data.item.attributes)" class="uil uil-eye font-size-18"></i>
                                  </div>
                               </template>

                                <template v-slot:cell(active)="data">
                                    <div class="col-4 form-check form-switch form-switch-lg">
                                        <input
                                                v-model="data.item.active"
                                                type="checkbox"
                                                class="form-check-input"
                                                id="switch1"
                                                true-value="1"
                                                false-value="0"
                                                disabled
                                                :style="{ left: '0px' }"
                                        />
                                    </div>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                              <template v-slot:cell(action)="data">
                                <ul class="list-inline mb-0">
                                  <li class="list-inline-item">
                                    <a href="javascript:void(0);" class="px-2 text-primary" title="Delete Automated Notification" @click="deleteNotification(data.item.id)">
                                      <i class="uil uil-trash-alt font-size-18"></i>
                                    </a>
                                  </li>
                                </ul>
                              </template>
                            </b-table>
                        </div>
                        <!--Table end -->

                        <div class="row" v-show="filterData">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- MODALS -->
        <ModalEditAutomatedNotification :notificationData="notificationData" @onRefresh="getAutomatedNotifications(verifyInput)"></ModalEditAutomatedNotification>
        <ModalViewNotificationAttributes :notificationData="notificationData"></ModalViewNotificationAttributes>
        <ModalAddAutomatedNotification :notificationData="notificationData" @onRefresh="getAutomatedNotifications(verifyInput)"></ModalAddAutomatedNotification>
        <ModalAddAutomatedNotificationSetup @onRefresh="getAutomatedNotifications(verifyInput)" :selectedTenant="verifyInput" ></ModalAddAutomatedNotificationSetup>
        <!-- /MODALS -->
    </Layout>
</template>

